import React, { useEffect, useMemo, useRef } from "react";
import type { SelectInstance } from "react-select";
import Select from "react-select";
import type { IndigenousCommunitySimpleListDto } from "@/api/types";

interface Props {
  value?: number;
  items: IndigenousCommunitySimpleListDto[];
  onSelect: (value: number) => void;
  placeholder: string;
}

export const CommunitySelect = ({
  items,
  placeholder,
  value,
  onSelect,
}: Props) => {
  const ref = useRef<SelectInstance>(null);
  const options = useMemo(
    () =>
      items.map((i) => ({
        label: i.name,
        value: i.id,
      })),
    [items],
  );

  useEffect(() => {
    if (!value) ref.current?.clearValue();
  }, [value]);

  return (
    <Select
      ref={ref}
      classNamePrefix="select"
      isDisabled={items.length === 0}
      isSearchable
      options={options as any}
      onChange={(option: any) => {
        if (option) onSelect(option.value);
      }}
      placeholder={placeholder}
    />
  );
};
